/// <reference path="search.module.ts" />

module Meevo.Components.Search {
    import ClientSearchView = Meevo.Model.ClientSearchView;

    export interface ISearchController extends ng.IScope {
        // properties for isolated scope
        clients: any;
        getData: any;
    }

    export class SearchController {
        // members
        private itemsPerPage: number = 25;
        protected visualState: Model.MaintenanceFormVisualState;
        filter: string;
        criteria: any;
        items: any;
        selectedItemId: Guid;
        selectedItemOwnedByLocationId: number;
        selectedItemAtLocationId: number;
        scope: any;
        current: any;
        displayAccordion: boolean;
        resized: boolean;
        recentSearches: any;
        infiniteScrollHeight: any;
        isLocalOnly: boolean;
        totalCount: any;
        maxRecentClient: number;
        isIncludeCheckOutChkShow: boolean;
        includeCheckOutApt: boolean;
        appointTodaySearch: boolean;
        landingTab: any;

        // When the enhanced global nav is on, the Client Find header gets the compact,
        // small-icon treatment (kept blue). Read from the business-info setting so the
        // header paints correctly on first render.
        public get isEnhancedGlobalNav(): boolean {
            return !!(this.appSettings.APP_BUSINFOSETTINGS
                && this.appSettings.APP_BUSINFOSETTINGS.generalSettings
                && this.appSettings.APP_BUSINFOSETTINGS.generalSettings.enableEnhancedGlobalNavigation);
        }

        // initialization
        static $inject = ["$rootScope", "$scope", "$q", "meevo.components.common.DataService", "meevo.components.common.RecentService", "meevo.components.tracking.TrackingService", 'meevo.components.common.IdentityService', 'meevo.AppSettings'];
        constructor(private $rootScope: ng.IRootScopeService,
            protected $scope: ng.IScope,
            protected $q: angular.IQService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            private recentService: Meevo.Components.Common.RecentService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            private appSettings: Meevo.Components.Common.IAppSettings) {
            let vm = this;
            vm.displayAccordion = false;
            vm.initializeState();
            vm.filter = "";
            vm.current = {};
            vm.criteria = {};
            vm.resized = false;
            vm.recentSearches = [];
            vm.isLocalOnly = true;
            vm.isIncludeCheckOutChkShow = true;
            vm.appointTodaySearch = false;
            vm.includeCheckOutApt = false;
            $scope.isCentralOffice = this.identityService.inCentralOfficeMode();
            this.setDefaultLandingTab();

            $scope.$watch("vm.filter", (filterNew: string, filterOld: any): void => {
                vm.filter = filterNew;
                if (filterNew != "" || filterOld != "") {
                    this.findClients();
                }
            });

            $scope.$on(Meevo.Components.Common.Messages.CLIENT_SELECTED, (event, client) => {
                if (this.current && this.current.id !== client.id)
                    vm.initializeState();
                //vm.insertRecentClient(client);
            });

            $scope.$on(Meevo.Components.Common.Messages.BOOK_APPOINTMENT_FOR_CLIENT, () => {
                vm.initializeState();
            });

            $scope.$on(Meevo.Components.Common.Messages.RING_UP_TRANSACTIONFOR_CLIENT, () => {
                vm.initializeState();
            });

            $scope.calcScrollHeight = (): any => {
                if (this.recentSearches.length == 0) {
                    var calc = 250;
                } else {
                    var calc = 271 + this.recentSearches.length * 31;
                }
                this.infiniteScrollHeight = {
                    'height': "calc(100% - " + calc + "px)"
                }
            }

            var self = this;
            $rootScope.$on(Meevo.Components.Common.Messages.OPEN_SEARCH_MENU_COMPLETE, function (event, args) {
                // When it opens, resize the virtual repeat container
                // b/c sometimes it doesn't render correctly.
                vm.initializeState();
                event.currentScope.$broadcast('$md-resize');
                $scope.calcScrollHeight();
                //if client is sent in args
                vm.loadClient(args);
                if (args && args.landingTab) {
                    vm.setLandingTab(args.landingTab);
                }
            });

            $rootScope.$on(Meevo.Components.Common.Messages.SEARCH_MENU_DELETE_CLIENT, function (event, args) {
                // When it opens, resize the virtual repeat container
                // b/c sometimes it doesn't render correctly.
                vm.initializeState();
                event.currentScope.$broadcast('$md-resize');
                self.recentService.deleteRecent(args.id, Meevo.Components.Common.Constants.RECENT_KEY_CLIENT);
                self.recentService.getRecentList(Meevo.Components.Common.Constants.RECENT_KEY_CLIENT)
                    .then((recentList) => {
                        self.recentSearches = recentList;
                    });
            });
        }

        // properties
        get showSearch(): boolean {
            return this.visualState === Model.MaintenanceFormVisualState.Search;
        }

        // methods
        initializeState(): void {
            this.visualState = Model.MaintenanceFormVisualState.Search;
            this.filter = "";
            this.displayAccordion = false;
        }
        closeMenu(): void {
            this.$rootScope.$broadcast('closeSearchMenu');
            this.initializeState();
        }
        detail = (id: Guid, ownedByLocationId: number, atLocationId: number): void => {
            this.selectedItemId = id;
            this.selectedItemOwnedByLocationId = ownedByLocationId;
            this.selectedItemAtLocationId = atLocationId;
            this.visualState = Model.MaintenanceFormVisualState.Detail;
        }
        findClients(): void {
            if (this.filter.length >= 4) {
                this.appointTodaySearch = false;
                this.isIncludeCheckOutChkShow = false;
                this.includeCheckOutApt = false;
                // Initalize results collection
                this.items = new Meevo.Components.BaseClasses.PagedResults(this.dataService, "client", this.updateClientsInfo());

                this.filter = this.filter.replace(/^\s+/, "");
                // Prepare request
                let request = {
                    pageNumber: 0,
                    itemsPerPage: this.itemsPerPage,
                    criteria: { includeActive: true, filter: this.filter, isGlobal: !this.isLocalOnly },
                    sortBy: '',
                    sortDirection: Model.SortDirection.Ascending,
                    includeActive: true,
                    includeDeleted: false,
                    includeInactive: false
                };

                // Execute request into ties
                this.items.initSearch(request, null).then((res) => {
                    this.totalCount = res
                })

                if (!this.resized) {
                    window.setTimeout(this.resizeVirtRepeat(), 100);
                    this.resized = true;
                }
            }
        }

        getClientsWithAppointment(): void {
            // Initalize results collection
            this.items = new Meevo.Components.BaseClasses.PagedResults(this.dataService, "client", this.updateClientsInfo());
            console.log(this.items);
            this.isIncludeCheckOutChkShow = true;
            // Prepare request
            let request = {
                pageNumber: 0,
                itemsPerPage: this.itemsPerPage,
                criteria: { view: Model.ClientSearchView.FromClientFind, includeActive: true, filter: this.filter, isCheckoutClientIncluded: this.includeCheckOutApt },
                sortBy: '',
                sortDirection: Model.SortDirection.Ascending,
                includeActive: true,
                includeDeleted: false,
                includeInactive: false
            };

            // Execute request into ties
            this.items.initSearch(request);

            if (!this.resized) {
                window.setTimeout(this.resizeVirtRepeat(), 100);
                this.resized = true;
            }

            this.clearSearchFilter();
        }


        findClientsAppointmentToday(): void {
            this.appointTodaySearch = true;
            this.getClientsWithAppointment();
            this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Meevo.Model.NounEnum.ClientFindAppointmentToday, Meevo.Model.VerbEnum.AppointmentTodayButtonClicked, null));

        }
        findClientsAppointmentsTodayIncludeCheckedOut(): void {
            this.getClientsWithAppointment();
            this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Meevo.Model.NounEnum.ClientFindIncludeCheckOut, Meevo.Model.VerbEnum.CheckBoxButtonClicked, null));
        }

        openDetails(client: any, openRecent: boolean = false): void {
            this.current = null;
            if (openRecent) {

                this.dataService.getItem("client", client.id)
                    .then((item: any) => {
                        this.current = item;
                        this.assignPrimaryPhoneNumber(item);
                        this.displayAccordion = true;
                    });
            }
            else {
                setTimeout(() => {
                    this.current = client;
                    this.assignPrimaryPhoneNumber(client);
                    this.displayAccordion = true;
                    this.recentService.addRecent(client, Meevo.Components.Common.Constants.RECENT_KEY_CLIENT, true);
                    this.$scope.calcScrollHeight();
                })
            }
        }

        assignPrimaryPhoneNumber(client: any) {
            if (client != null && client.phoneNumbers != null) {
                let primaryPhone: any = _.findWhere(client.phoneNumbers, { isPrimary: true });
                if (primaryPhone) {
                    this.current.primaryPhoneNumber = primaryPhone.number;
                    this.current.primaryPhoneNumberCountryCode = primaryPhone.countryCode;
                }
            }
        }


        clearRecentSearches(): void {
            this.recentSearches = [];
            this.recentService.clearRecent(Meevo.Components.Common.Constants.RECENT_KEY_CLIENT);
            this.$scope.calcScrollHeight();
        }

        clearSearchFilter(): void {
            this.filter = "";
        }

        searchOnEnter(event: any): void {
            if (event.which == 13 && this.filter == '') {
                this.findClients();
                this.$scope.calcScrollHeight();
            }
        }

        createNewClient(): void {
            this.goToState("client");
        }

        addNewClientParams = {
            "callbackController": false,
            "callbackState": null,
            "targetState": Meevo.Model.MaintenanceFormVisualState.Detail,
            "actionState": Meevo.Model.MaintenanceFormState.Adding,
            "initialEditSection": "SECTION_CLIENT_MAIN",
            "employeeClientLinkDetails": null,
        }

        goToState(stateName) {
            this.$rootScope.$broadcast("gotoState", {
                stateName: stateName,
                stateParams: this.addNewClientParams
            });
        }

        resizeVirtRepeat(): any {
            this.$scope.$broadcast('$md-resize');
        }

        searchOnGlobalChanged(): void {
            if (this.filter.length > 0) {
                this.findClients();
            }
        }

        backToSearch() {
            this.displayAccordion = false;
            let that = this;
            this.setRecentSearches();
            window.setTimeout(function () {
                that.resizeVirtRepeat()
            }, 1000);
        }

        /**
        * Callback function from infinity scroll(Page Result).
        * Go through clients and check if they sent to Transworld
        * @param {number} pageNumber
        * @param {any} clients
        */
        updateClientsInfo(): (pageNumber, clients: any) => void {
            let transworldStatus = this.dataService.customMethodData(`/${Meevo.AppSettings.Default.API_ROOT}/settings/transworldFields/`, 'GET', null)
                .then(res => res.data.enableTransworld);

            return (pageNumber, clients: any): void => {
                transworldStatus.then((isTransworldEnabled: boolean) => {
                    if (clients && clients.length && isTransworldEnabled) {
                        return this.dataService.customMethodData(`/${Meevo.AppSettings.Default.API_ROOT}/Transworld/Client/List/`, 'POST', { clients: clients.map(client => client.id) });
                    }

                    return this.$q.reject();
                }).then(res => {
                    const formatedClientsList: any = _.indexBy(res.data, 'clientId');
                    clients.forEach(client => {
                        client.isSentToTransworld = formatedClientsList[client.id].isSentToTransworld;
                    });
                });
            }
        }

        setRecentSearches() {
            this.recentService.getRecentList(Meevo.Components.Common.Constants.RECENT_KEY_CLIENT)
                .then((recentList) => {
                    this.recentSearches = recentList;
                });
        }

        loadClient(client: any) {
            if (!_.isNull(client) && client.id) {
                this.dataService.getItem("client/", client.id).then((response) => {
                    this.openDetails(response);
                });
            }
            else {
                this.setRecentSearches();
            }
        }

        setDefaultLandingTab() {
            this.landingTab = Model.NounEnum.ClientFindAppointmentHistoryTab;
        }

        setLandingTab(tab: Meevo.Model.NounEnum) {
            if (tab) {
                this.landingTab = tab;
            }
        }
    }

    // controller registration with module
    angular.module("meevo.components.search")
        .controller("meevo.components.search.SearchController", SearchController);
}